/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";

// @material-ui/core components
import {
  Box,
  Button,
  ButtonBase,
  Dialog,
  DialogActions,
  DialogContent,
  FormControlLabel,
  Checkbox,
  FormGroup,
  FormLabel,
  Grid,
  Paper,
  Radio,
  RadioGroup,
  TextField,
  CircularProgress,
  Typography,
  CardContent,
  FormControl,
  Select,
  MenuItem,
} from "@material-ui/core";

import { KeyboardArrowDown } from "@material-ui/icons";

import { createStyles, makeStyles, withStyles } from "@material-ui/core/styles";

import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import Api from "lib/api/httpRequestHelper";
import ImagePlaceholder from "components/Image/ImagePlaceholder";
import componentStylesDialog from "assets/theme/components/dialog";
import { IsMobile } from "utils/is-mobile";

const useStyles = makeStyles({
  paper: { overflow: "hidden" },
  img: {
    margin: "auto",
    display: "block",
    maxWidth: "100%",
    maxHeight: "100%",
  },
  image: {
    width: 80,
    height: 80,
  },
  buttonStyle: {
    border: "none",
    background: "transparent",
    color: "grey",
    "&:hover": {
      color: "#DF767D",
      textDecoration: "underline",
    },
  },
});

const useStylesRadio = makeStyles((theme) =>
  createStyles({
    smallRadioButton: {
      "& svg": {
        width: "5rem",
        height: "5rem",
      },
    },
  })
);

const useStylesDialog = makeStyles(componentStylesDialog);

const RadioOption = withStyles(() => ({
  label: {
    fontSize: "0.95rem",
  },
  root: {
    marginBottom: 0,
  },
}))(FormControlLabel);

const typeExchangeList = [
  {
    name: "Devolução",
    value: "DEVOLUCAO",
    id: 1,
  },
  {
    name: "Troca",
    value: "TROCA",
    id: 2,
  },
];

const ProductEditExchangeDialog = ({
  itens,
  idPessoaLoja,
  onClose,
  idDevolucao,
}) => {
  const snackbar = useSnackbar();
  const classes = { ...useStyles(), ...useStylesDialog(), ...useStylesRadio() };
  const detailsRef = useRef(null);

  const isMobile = IsMobile();

  const [submitting, setSubmitting] = useState(false);
  const [listItens, setListItens] = useState([]);
  const [hasChanges, setHasChanges] = useState(false);

  const onSubmit = async () => {
    const listDeleteItems = [];
    const listEditItems = [];
    let success = false;
    setSubmitting(true);

    listItens?.map((item) => {
      if (item?.ExcluirItem) {
        listDeleteItems?.push(item?.IdTrocaDevolucaoItem);
      }

      if (!item?.ExcluirItem && item?.EditarItem) {
        listEditItems?.push(item);
      }
    });

    if (listDeleteItems?.length !== 0) {
      await Api.delete(
        "delete-change-product-item",
        "trocas",
        {
          idTrocaDevolucao: idDevolucao,
          idsTrocaDevolucaoItem: listDeleteItems?.toString(),
        },
        true
      )
        .then((res) => {
          if (res?.Success) {
            snackbar.showMessage("Solicitação alterada com sucesso!", {
              severity: "success",
            });
            success = true;
          }
        })
        .catch((error) => {
          console.log(error);
          snackbar.showMessage(error, {
            severity: "error",
          });
          success = false;        })
        .finally(() => setSubmitting(false));
    }

    if (listEditItems?.length !== 0) {
      const listExchanges = [];
      let newObject = {};

      listEditItems?.map((item) => {
        if (item?.IdTrocaDevolucaoItem) {
          newObject = {
            idTrocaDevolucaoItem: item?.IdTrocaDevolucaoItem,
            idProduto: item?.IdProduto,
            motivo: item?.Motivo,
            quantidadeTroca: item?.QuantidadeSolicitada || 0,
            tipoSolicitacao: item?.TipoSolicitacao,
            observacao: item?.Observacao,
            idPedido: item?.IdPedido,
          };
          listExchanges.push(newObject);
        }
      });

      await Api.put(
        "edit-order-change-product",
        "trocas",
        {
          idTrocaDevolucao: idDevolucao,
          itens: listExchanges,
        },
        true
      )
        .then((res) => {
          if (res?.Success) {
            snackbar.showMessage("Solicitação realizada com sucesso!", {
              severity: "success",
            });
            success = true;
          }
        })
        .catch((error) => {
          console.log(error);
          snackbar.showMessage(error, {
            severity: "error",
          });
          success = false;        })
        .finally(() => setSubmitting(false));
    }
    if (success) {
      onClose(idDevolucao);
    }
  };

  useEffect(() => {
    const list = [];
    let newObject = {};

    if (itens && idPessoaLoja) {
      itens?.ListDevolucaoTroca?.map((item) => {
        newObject = {
          DescricaoProduto: item?.DescricaoProduto,
          Foto: item?.Foto,
          IdPedido: item?.IdPedido,
          IdProduto: item?.IdProduto,
          IdTrocaDevolucao: item?.IdTrocaDevolucao,
          IdTrocaDevolucaoItem: item?.IdTrocaDevolucaoItem,
          Motivo: item?.Motivo,
          Observacao: item?.Observacao || "",
          QuantidadeOriginal: item?.QuantidadeOriginal,
          QuantidadeRestante: item?.QuantidadeRestante,
          QuantidadeTroca: item?.QuantidadeTroca,
          QuantidadeSolicitada: "",
          TipoSolicitacao: item?.TipoSolicitacao,
          ExcluirItem: false,
          EditarItem: false,
        };
        list.push(newObject);
      });
      setListItens(list);
    }
  }, [itens, idPessoaLoja]);

  return (
    <Dialog
      open={Boolean(itens)}
      onClose={() => onClose()}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
      classes={{ paper: classes.paper }}
      maxWidth="lg"
    >
      <div
        className={classes.dialogHeader}
        style={{
          display: "flex",
          justifyContent: isMobile ? "flex-start" : "space-between",
          alignItems: isMobile ? "flex-start" : "center",
          flexDirection: isMobile ? "column" : "row",
        }}
      >
        <Typography variant="h5" component="h5" className={classes.dialogTitle}>
          Edição de Troca / Devolução
        </Typography>
      </div>

      <>
        <DialogContent
          ref={detailsRef}
          style={{
            paddingRight: "0px",
            marginRight: "1.5rem",
            overflowX: "hidden",
          }}
        >
          <>
            <Grid container>
              <Grid item xs={12}>
                <Grid container hidden={listItens?.length === 0}>
                  <Grid item xs={12}>
                    <CardContent>
                      <Grid container>
                        <Grid item xs={12}>
                          {listItens.map((itemAtendimento, index) => {
                            return (
                              <Paper
                                key={index}
                                className={classes.paper}
                                style={{
                                  marginBottom: "0.75rem",
                                  border: itemAtendimento?.ExcluirItem
                                    ? "1px solid #DF767D"
                                    : "",
                                }}
                              >
                                <Grid
                                  container
                                  spacing={1}
                                  style={{ position: "relative" }}
                                >
                                  <Grid item>
                                    <ButtonBase className={classes.image}>
                                      <ImagePlaceholder
                                        className={classes.img}
                                        alt="Imagem do item do atendimento"
                                        src={itemAtendimento?.Foto}
                                        width={75}
                                        widthOnError={40}
                                        imagePreviewTitle={`Item ${itemAtendimento?.IdProduto}`}
                                      />
                                    </ButtonBase>
                                  </Grid>
                                  <Grid
                                    item
                                    xs={isMobile ? 12 : 6}
                                    sm
                                    container
                                    style={{ margin: "0.5rem 0" }}
                                  >
                                    <Grid
                                      item
                                      xs={isMobile ? 12 : "auto"}
                                      container
                                      spacing={1}
                                      display="flex"
                                    >
                                      <Grid item xs={isMobile ? 10 : 6}>
                                        <Typography
                                          gutterBottom
                                          variant="subtitle2"
                                          style={{ fontSize: "13px" }}
                                        >
                                          {itemAtendimento?.DescricaoProduto}
                                        </Typography>
                                        <Typography
                                          variant="body2"
                                          color="textSecondary"
                                          style={{ fontSize: "13px" }}
                                        >
                                          Código do Produto :{" "}
                                          {itemAtendimento?.IdProduto}
                                        </Typography>
                                        <Typography
                                          variant="subtitle2"
                                          style={{ fontSize: "13px" }}
                                        >
                                          Quantidade Original :{" "}
                                          {itemAtendimento?.QuantidadeOriginal}
                                        </Typography>
                                        <Typography
                                          variant="subtitle2"
                                          style={{ fontSize: "13px" }}
                                        >
                                          Quantidade Troca / Devolução :{" "}
                                          {itemAtendimento?.QuantidadeTroca}
                                        </Typography>
                                        <>
                                          {itemAtendimento?.QuantidadeRestante !==
                                            null && (
                                            <Typography
                                              variant="subtitle2"
                                              style={{ fontSize: "13px" }}
                                            >
                                              Quantidade Restante :{" "}
                                              {
                                                itemAtendimento?.QuantidadeRestante
                                              }
                                            </Typography>
                                          )}
                                        </>
                                      </Grid>

                                      <Grid
                                        item
                                        xs={isMobile ? 12 : 6}
                                        style={{
                                          display: "flex",
                                          flexDirection: "column",
                                        }}
                                      >
                                        <Grid container>
                                          <Grid
                                            item
                                            xs={isMobile ? 12 : 6}
                                            style={{
                                              marginBottom: isMobile
                                                ? "1rem"
                                                : 0,
                                            }}
                                          >
                                            <FormGroup>
                                              <FormLabel
                                                style={{ fontSize: "12px" }}
                                              >
                                                MOTIVO
                                              </FormLabel>
                                              <FormControl
                                                variant="outlined"
                                                fullWidth
                                                disabled={
                                                  submitting ||
                                                  itemAtendimento.QuantidadeRestante ===
                                                    0
                                                }
                                                style={{ height: "0.5rem" }}
                                              >
                                                <Select
                                                  style={{ height: "2rem" }}
                                                  name="motivo"
                                                  value={
                                                    itemAtendimento.QuantidadeRestante ===
                                                    0
                                                      ? ""
                                                      : itemAtendimento?.Motivo
                                                  }
                                                  onChange={(e) => {
                                                    setHasChanges(true);
                                                    setListItens(
                                                      listItens.map((item) => {
                                                        if (
                                                          item?.IdTrocaDevolucaoItem ===
                                                          itemAtendimento?.IdTrocaDevolucaoItem
                                                        ) {
                                                          if (
                                                            e.target.value !==
                                                            "0"
                                                          ) {
                                                            return {
                                                              ...item,
                                                              Motivo:
                                                                e.target.value,
                                                              EditarItem: true,
                                                            };
                                                          } else {
                                                            return {
                                                              ...item,
                                                              Motivo: "",
                                                            };
                                                          }
                                                        } else {
                                                          return item;
                                                        }
                                                      })
                                                    );
                                                  }}
                                                  IconComponent={
                                                    KeyboardArrowDown
                                                  }
                                                >
                                                  <MenuItem value={""}>
                                                    Selecione...
                                                  </MenuItem>
                                                  <MenuItem
                                                    value={"ARREPENDIMENTO"}
                                                  >
                                                    Arrependimento/Desistência
                                                  </MenuItem>
                                                  <MenuItem value={"DEFEITO"}>
                                                    Produto com defeito
                                                  </MenuItem>
                                                  <MenuItem value={"NAOGOSTOU"}>
                                                    Não gostou
                                                  </MenuItem>
                                                  <MenuItem value={"OUTROS"}>
                                                    Outros
                                                  </MenuItem>
                                                </Select>
                                              </FormControl>
                                            </FormGroup>
                                          </Grid>
                                          <Grid item xs={isMobile ? 12 : 6}>
                                            <FormGroup>
                                              <FormLabel
                                                style={{ fontSize: "12px" }}
                                              >
                                                QUANTIDADE
                                              </FormLabel>
                                              <TextField
                                                name="quantidade"
                                                type="number"
                                                fullWidth
                                                disabled={
                                                  submitting ||
                                                  itemAtendimento.QuantidadeRestante ===
                                                    0
                                                }
                                                value={
                                                  itemAtendimento?.QuantidadeSolicitada
                                                }
                                                variant="outlined"
                                                inputProps={{
                                                  max: itemAtendimento?.QuantidadeRestante
                                                    ? itemAtendimento?.QuantidadeRestante
                                                    : itemAtendimento?.QuantidadeOriginal,
                                                  min: 0,
                                                  onKeyDown: (event) => {
                                                    event.preventDefault();
                                                  },
                                                  style: {
                                                    height: "2rem",
                                                  },
                                                }}
                                                onInput={(e) => {
                                                  setHasChanges(true);
                                                  setListItens(
                                                    listItens.map((item) => {
                                                      if (
                                                        item?.IdTrocaDevolucaoItem ===
                                                        itemAtendimento?.IdTrocaDevolucaoItem
                                                      ) {
                                                        if (
                                                          e.target.value !== "0"
                                                        ) {
                                                          return {
                                                            ...item,
                                                            QuantidadeSolicitada:
                                                              parseInt(
                                                                e.target.value
                                                              ),
                                                            EditarItem: true,
                                                          };
                                                        } else {
                                                          return {
                                                            ...item,
                                                            QuantidadeSolicitada:
                                                              "",
                                                          };
                                                        }
                                                      } else {
                                                        return item;
                                                      }
                                                    })
                                                  );
                                                }}
                                              />
                                            </FormGroup>
                                          </Grid>
                                        </Grid>
                                        <Grid
                                          container
                                          style={{ marginBottom: "-1rem" }}
                                        >
                                          <Grid
                                            item
                                            xs={isMobile ? 12 : 6}
                                            style={{
                                              marginBottom: isMobile
                                                ? "-1.5rem"
                                                : 0,
                                            }}
                                          >
                                            <FormGroup>
                                              <FormLabel
                                                style={{ fontSize: "12px" }}
                                              >
                                                TIPO DE SOLICITAÇÃO
                                              </FormLabel>
                                              <RadioGroup
                                                aria-label="opções de solicitação"
                                                required
                                                name="tipo"
                                                value={itemAtendimento?.Tipo}
                                                disabled={
                                                  submitting ||
                                                  itemAtendimento.QuantidadeRestante ===
                                                    0
                                                }
                                                style={{
                                                  display: "flex",
                                                  flexDirection: "row",
                                                }}
                                                onChange={(e) => {
                                                  setHasChanges(true);
                                                  setListItens(
                                                    listItens.map((item) => {
                                                      if (
                                                        item?.IdTrocaDevolucaoItem ===
                                                        itemAtendimento?.IdTrocaDevolucaoItem
                                                      ) {
                                                        return {
                                                          ...item,
                                                          TipoSolicitacao:
                                                            e.target.value,
                                                          EditarItem: true,
                                                        };
                                                      } else {
                                                        return item;
                                                      }
                                                    })
                                                  );
                                                }}
                                              >
                                                {typeExchangeList.map(
                                                  (type) => {
                                                    return (
                                                      <RadioOption
                                                        disabled={
                                                          submitting ||
                                                          itemAtendimento.QuantidadeRestante ===
                                                            0
                                                        }
                                                        className={
                                                          classes.smallRadioButton
                                                        }
                                                        key={type?.id}
                                                        value={type?.value}
                                                        checked={
                                                          itemAtendimento?.TipoSolicitacao ===
                                                          type?.value
                                                        }
                                                        control={
                                                          <Radio color="primary" />
                                                        }
                                                        label={type.name}
                                                      />
                                                    );
                                                  }
                                                )}
                                              </RadioGroup>
                                            </FormGroup>
                                          </Grid>
                                          <Grid item xs={isMobile ? 12 : 6}>
                                            <FormGroup>
                                              <FormLabel
                                                style={{ fontSize: "12px" }}
                                              >
                                                OBSERVAÇÃO
                                              </FormLabel>
                                              <TextField
                                                name="observacao"
                                                fullWidth
                                                multiline
                                                rows="3"
                                                onChange={(e) => {
                                                  setHasChanges(true);
                                                  setListItens(
                                                    listItens.map((item) => {
                                                      if (
                                                        item?.IdTrocaDevolucaoItem ===
                                                        itemAtendimento?.IdTrocaDevolucaoItem
                                                      ) {
                                                        if (
                                                          e.target.value !== "0"
                                                        ) {
                                                          return {
                                                            ...item,
                                                            Observacao:
                                                              e.target.value,
                                                            EditarItem: true,
                                                          };
                                                        } else {
                                                          return {
                                                            ...item,
                                                            Observacao: "",
                                                          };
                                                        }
                                                      } else {
                                                        return item;
                                                      }
                                                    })
                                                  );
                                                }}
                                                disabled={
                                                  submitting ||
                                                  itemAtendimento.QuantidadeRestante ===
                                                    0
                                                }
                                                value={
                                                  itemAtendimento.QuantidadeRestante ===
                                                  0
                                                    ? ""
                                                    : itemAtendimento?.Observacao
                                                }
                                                variant="outlined"
                                                inputProps={{ min: 0 }}
                                              />
                                            </FormGroup>
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                  </Grid>

                                  <FormGroup
                                    style={{
                                      padding: "0 0.5rem",
                                      position: "absolute",
                                      display: "flex",
                                      flexDirection: "row",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      bottom: 0,
                                      left: 5,
                                    }}
                                  >
                                    <Checkbox
                                      checked={itemAtendimento?.ExcluirItem}
                                      color="primary"
                                      onChange={(e) => {
                                        setHasChanges(true);
                                        setListItens(
                                          listItens.map((item) => {
                                            if (
                                              item?.IdTrocaDevolucaoItem ===
                                              itemAtendimento?.IdTrocaDevolucaoItem
                                            ) {
                                              return {
                                                ...item,
                                                ExcluirItem: e.target.checked,
                                              };
                                            } else {
                                              return item;
                                            }
                                          })
                                        );
                                      }}
                                    />
                                    <FormLabel
                                      style={{
                                        fontSize: "12px",
                                        marginTop: "0.5rem",
                                      }}
                                    >
                                      Excluir
                                    </FormLabel>
                                  </FormGroup>
                                </Grid>
                              </Paper>
                            );
                          })}
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </>
        </DialogContent>

        <DialogActions>
          <Button
            component={Box}
            onClick={() => onClose()}
            disabled={submitting}
          >
            Cancelar
          </Button>
          <Button
            component={Box}
            onClick={onSubmit}
            color="default"
            variant="contained"
            disabled={submitting || !hasChanges}
          >
            {submitting ? "Atualizando solicitação..." : "Atualizar"}
            {submitting ? (
              <CircularProgress style={{ marginLeft: 5 }} size={16} />
            ) : null}
          </Button>
        </DialogActions>
      </>
    </Dialog>
  );
};

export default ProductEditExchangeDialog;
